import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ListadoSupport from "./ListadoSupport";

const SupportAdmin = ({ token }) => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("listado");
  const [debeRecargar, setDebeRecargar] = useState(false);

  const renderTab = () => { 
    switch (tab) {
      case "listado":
        return <ListadoSupport token={token} debeRecargar={debeRecargar} 
          onRecargaCompleta={() => setDebeRecargar(false)} />;
      default:
        return null;
    }
  };

  return (
    <div className="productos-admin-content">
      <div className="productos-admin-header">
        <div className="productos-admin-header-row">
          <div>
            <div className="productos-admin-title">Cola de Soporte</div>
            <div className="productos-admin-subtitle">
              Gestión de solicitudes
            </div>
          </div>
        </div>
        {/* <div className="productos-admin-tabs">
          <Permiso permiso="list_products">
            <button
              className={tab === "listado" ? "active" : ""}
              onClick={() => setTab("listado")}
            >
              Listado de Solicitudes
            </button>
          </Permiso>
        </div> */}
      </div>
      <div className="productos-admin-tab-content">{renderTab()}</div>
    </div>
  );
};

export default SupportAdmin;
